<app-header [forceLightBackground]="true"></app-header>
<section class="thank-you">
  <div class="thank-you--content">
    <div class="thank-you--container">
      <div class="thank-you--card">
        <div class="thank-you--card-accent"></div>
        <div class="thank-you--card-body">
          <div class="thank-you--icon-wrap">
            <svg class="thank-you--icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <h2 class="thank-you--title">Message received</h2>
          <p class="thank-you--lead">
            Thank you for getting in touch with the MahaAgX team.
          </p>
          <p class="thank-you--text">
            We have received your contact details and message. Our team will review your inquiry and respond to you as soon as possible.
          </p>
          <p class="thank-you--text">
            In the meantime, you can explore our <a routerLink="/datasets" class="thank-you--link">datasets</a>, <a routerLink="/models" class="thank-you--link">models</a>, or <a routerLink="/challenges" class="thank-you--link">challenges</a> on the platform.
          </p>
          <a routerLink="/" class="thank-you--btn">Back to home</a>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
